import {initModel3d} from "../../../spGlobal/js/shop/model3d";

window.addEventListener("load", () => {
    initModel3d();
});
